export default "__VITE_ASSET__Ubi2v1DB__"